export default __webpack_public_path__ + "0326052ceb3b627217e391000f405c72.png";